import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

interface FilePreviewPopoverProps {
  fileUrl: string | File | null;
  index?: number;
  displayText?: string;
}

const FilePreviewPopover: React.FC<FilePreviewPopoverProps> = ({
  fileUrl,
  index = 0,
  displayText,
}) => {
  // Helper function to ensure image URL is absolute
  const getImageUrl = (url: string): string => {
    if (!url) return "";
    // If URL is already absolute (starts with http:// or https://), return as is
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    // If URL starts with /, it's a relative path - make it absolute
    if (url.startsWith("/")) {
      // Get the current origin (protocol + host + port)
      const origin = window.location.origin;
      return `${origin}${url}`;
    }
    // Otherwise, assume it's already a full URL or return as is
    return url;
  };

  // If no file, return dash
  if (!fileUrl) {
    return <span>-</span>;
  }

  // If it's a File object, show the file name
  if (fileUrl instanceof File) {
    return <span style={{ fontSize: "12px" }}>{fileUrl.name || "File"}</span>;
  }

  // If it's a string URL, show the preview popover
  if (typeof fileUrl === "string") {
    const imageUrl = getImageUrl(fileUrl);
    const fileName = displayText || fileUrl.split("/").pop() || "File";

    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="top"
        overlay={
          <Popover
            id={`file-preview-${index}`}
            style={{ maxWidth: "300px" }}
          >
            <Popover.Header as="h6" style={{ fontSize: "12px" }}>
              File Preview
            </Popover.Header>
            <Popover.Body style={{ padding: "8px" }}>
              <div
                style={{
                  position: "relative",
                  minHeight: "50px",
                  textAlign: "center",
                }}
              >
                <img
                  key={`img-${index}-${fileUrl}`}
                  src={imageUrl}
                  alt="File preview"
                  loading="eager"
                  crossOrigin="anonymous"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                    width: "auto",
                    height: "auto",
                    objectFit: "contain",
                    display: "block",
                    margin: "0 auto",
                  }}
                  onLoad={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = "block";
                    target.style.visibility = "visible";
                  }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = "none";
                    const parent = target.parentElement;
                    if (parent) {
                      parent.innerHTML = `<div style="text-align: center; padding: 10px;"><span style="font-size: 11px; color: #666;">Preview not available</span><br/><a href="${imageUrl}" target="_blank" rel="noopener noreferrer" style="font-size: 10px; color: #007bff; text-decoration: underline; margin-top: 5px; display: inline-block;">Open in new tab</a></div>`;
                    }
                  }}
                />
              </div>
            </Popover.Body>
          </Popover>
        }
      >
        <a
          href={imageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary text-decoration-underline"
          style={{
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          {/* {fileName} */}
          View
        </a>
      </OverlayTrigger>
    );
  }

  return <span>-</span>;
};

export default FilePreviewPopover;

